import { Roles } from "../../constants/roles";
import { FormBase } from "../form-base-form";

class InfoTooltipForm extends FormBase {
    private static readonly tooltipTriggerSelector = "[data-info-tooltip-source], .bi-info-circle";

    public getTooltipSource(root: ParentNode, sourceId: string): HTMLElement | null {
        return this.queryElement(root, `[data-role="${sourceId}"]`, HTMLElement);
    }

    public getEventTarget(event: Event): Element | null {
        return this.fromEventTarget(event, Element);
    }

    public getTooltipTrigger(element: Element | null | undefined): HTMLElement | null {
        return this.closest(element, InfoTooltipForm.tooltipTriggerSelector, HTMLElement);
    }

    public getTooltipFallbackHost(element: Element | null | undefined): HTMLElement | null {
        return this.closest(element, "a, button, [title], [aria-label]", HTMLElement);
    }

    public getNestedTooltipSource(trigger: ParentNode): HTMLElement | null {
        return this.queryElement(trigger, `[data-role="${Roles.INFO_TOOLTIP_SOURCE}"]`, HTMLElement);
    }
}

const infoTooltipForm = new InfoTooltipForm();

export { InfoTooltipForm, infoTooltipForm };
